import React from 'react';

// Simple pill switch. `checked`/`onChange` are required; `disabled` greys it
// out and blocks clicks (used when a parent switch is off).
export default function Toggle({ checked, onChange, disabled, label }) {
  return (
    <label
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <span
        role="switch"
        aria-checked={checked}
        onClick={() => { if (!disabled) onChange?.(!checked); }}
        style={{
          position: 'relative', width: 38, height: 22, borderRadius: 99, flexShrink: 0,
          background: checked ? '#2563eb' : 'var(--border-strong, #cbd5e1)',
          transition: 'background .15s',
        }}
      >
        <span
          style={{
            position: 'absolute', top: 2, left: checked ? 18 : 2,
            width: 18, height: 18, borderRadius: '50%', background: '#fff',
            boxShadow: '0 1px 2px rgba(0,0,0,0.25)', transition: 'left .15s',
          }}
        />
      </span>
      {label && <span style={{ fontSize: 13, color: 'var(--text-primary)' }}>{label}</span>}
    </label>
  );
}
